import React, { useState, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import CheckIcon from "../../../../../icons/check.icon";
import PlusIcon from "../../../../../icons/plus.icon";
import SelectArrowIcon from "../../../../../icons/select-arrow.icon";
import styles from "./status-dropdown.module.scss";

export const StatusDropdown = ({ value = "Mixed Statuses", onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [menuItems] = useState([
    {
      id: "trial-started",
      label: "Trial Started",
      indented: false,
    },
    { id: "stack-review", label: "Stack Review", indented: true },
    { id: "onboarding", label: "Onboarding", indented: true },
    { id: "decision", label: "Decision", indented: true },
    { id: "won", label: "Won", indented: true },
    { id: "archived", label: "Archived", indented: true },
  ]);

  const filteredMenuItems = useMemo(() => {
    if (!searchValue) {
      return menuItems;
    }
    return menuItems.filter((item) =>
      item.label.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [menuItems, searchValue]);

  const handleItemClick = (item) => {
    if (onChange) {
      onChange(item.label);
    }
    setSearchValue("");
    setIsOpen(false);
  };

  const handleAddNewStatus = () => {
    // Handle add new status action
    setSearchValue("");
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    setIsOpen(true);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
    setSearchValue("");
    setIsOpen(true);
  };

  const handleInputFocus = () => {
    setSearchValue("");
    setIsOpen(true);
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <Dropdown
      show={isOpen}
      onToggle={() => setIsOpen(!isOpen)}
      className={styles.statusDropdown}
    >
      <Dropdown.Toggle 
        as="div" 
        className={styles.statusSelectToggle}
        onClick={handleToggleClick}
        aria-expanded={isOpen}
      >
        <div className={styles.statusSelectContent}>
          <input
            type="text"
            className={styles.statusSelectInput}
            value={searchValue || (isOpen ? "" : value)}
            onChange={handleInputChange}
            onClick={handleInputClick}
            onFocus={handleInputFocus}
            placeholder={value}
          />
        </div>
        <div className={styles.statusSelectButton}>
          <SelectArrowIcon 
            fill="#616778" 
            width="8.485" 
            height="5.185"
            style={{ width: '8.485px', height: '5.185px' }}
          />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenu}>
        <div className={styles.menuContainer} role="menu">
          {filteredMenuItems.length > 0 ? filteredMenuItems.map((item) => (
            <div
              key={item.id}
              className={`${styles.menuItem} ${item.indented ? styles.menuItemIndented : styles.menuItemNotIndented} ${!item.indented ? styles.menuItemHighlighted : ""}`}
              role="menuitem"
              tabIndex={0}
              onClick={() => handleItemClick(item)}
            >
              <div className={styles.checkIconWrapper}>
                {value === item.label && (
                  <CheckIcon className={styles.checkIcon} width={16} height={16} fill="#616778" />
                )}
              </div>

              <div className={styles.menuItemLabel}>
                <div className={styles.menuItemText}>
                  {item.label}
                </div>
              </div>
            </div>
          )) : (
            <div className={styles.noResultsItem}>
              <div className={styles.noResultsText}>
                No statuses found
              </div>
            </div>
          )}

          {filteredMenuItems.length > 0 && (
          <div
            className={styles.addNewStatusItem}
            role="menuitem"
            tabIndex={0}
            onClick={handleAddNewStatus}
          >
            <div className={styles.addNewStatusContent}>
              <div className={styles.addIconWrapper}>
                <PlusIcon className={styles.addIcon} width={16} height={16} style={{ fill: '#008FD4' }} />
              </div>

              <div className={styles.addNewStatusText}>
                Add New Status
              </div>
            </div>
          </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

